// extracted by mini-css-extract-plugin
export var root = "_0d70c8ac50e51f4019eb2fa1ea24c23a-css";